import { useEffect } from 'react';
import { useAppDispatch } from 'src/store';
import { loadStoredCustomerId, setCurrentCustomerId } from 'src/app/customers/state/customersSlice';
import { loadStoredProjectId } from 'src/app/projects/views/project-list/state/projectListSlice';
import { loadStoredRoutesConfig } from 'src/routes/state/routesSlice';
import useAuthService from 'src/shared/hooks/useAuthService';
import { once } from 'lodash';

const readCustomerIdFromLocationSearch = (): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    return new URLSearchParams(window.location.search).get('customerId');
};

// load redux state from browser storage once when the application mounts
const useRestoredReduxState = () => {
    const dispatch = useAppDispatch();
    const { isAuthenticated } = useAuthService();

    useEffect(() => {
        const restoreState = once(async () => {
            if (isAuthenticated) {
                // Projects
                dispatch(loadStoredProjectId());

                // Customers: URL wins over session storage so deep links and e2e `?customerId=` are not overwritten
                // by a previously selected portfolio customer.
                const customerIdFromUrl = readCustomerIdFromLocationSearch();
                if (customerIdFromUrl) {
                    dispatch(setCurrentCustomerId(customerIdFromUrl));
                } else {
                    dispatch(loadStoredCustomerId());
                }

                // Routes config
                dispatch(loadStoredRoutesConfig());
            }
        });
        restoreState();
    }, []);
};

export default useRestoredReduxState;
